import gql from "graphql-tag";

export const GET_DASHBOARD_4_CONTRACTOR = gql`
    query ($startDate: String!, $endDate: String!,  $sites: [String!]!, $permitStatus: String!) {
        GetDashboard4ByDateRangeSitePermitStatusAndContractor(startDate: $startDate, endDate: $endDate, sites: $sites, permitStatus: $permitStatus) {
            code
            success
            message
            results {
                contractorCompany
                generalPermitCount
                toolPermitCount
                childPermitCount
            }
        }
    }
`;

export const GET_DASHBOARD_4_DISCIPLINE = gql`
    query ($startDate: String!, $endDate: String!, $sites: [String!]!, $permitStatus: String!) {
        GetDashboard4ByDateRangeSitePermitStatusAndDiscipline(startDate: $startDate, endDate: $endDate, sites: $sites, permitStatus: $permitStatus) {
            code
            success
            message
            results {
                discipline
                generalPermitCount
                toolPermitCount
                childPermitCount
            }
        }
    }
`;

export const GET_DASHBOARD_4_LEVEL = gql`
    query ($startDate: String!, $endDate: String!, $sites: [String!]!, $permitStatus: String!) {
        GetDashboard4ByDateRangeSitePermitStatusAndLevel(startDate: $startDate, endDate: $endDate, sites: $sites, permitStatus: $permitStatus) {
            code
            success
            message
            results {
                level
                generalPermitCount
                toolPermitCount
                childPermitCount
            }
        }
    }
`;

export const GET_DASHBOARD_4_CHILD_PERMIT = gql`
    query ($startDate: String!, $endDate: String!, $sites: [String!]!, $childPermitType: String!) {
        GetDashboard4ByDateRangeSitePermitStatusAndChildPermitType(startDate: $startDate, endDate: $endDate, sites: $sites, childPermitType: $childPermitType) {
            code
            success
            message
            results {
                _id
                title
                childPermitType
                pendingPMApprovalCount
                pendingIndividualReviewerCount
                pendingMTGroupApprovalCount
                approvedCount
            }
        }
    }
`;